import { useCallback } from "react";
import { useDictionary } from "./hooks/use-dictionary";

export const useValidateSpelling = () => {
    const { dictionary } = useDictionary();

    return useCallback(
        (value, validation) => {
            const spellingErrors = [];

            const getSpellingErrorsList = (values) => {
                const string = charactersOnly(values);
                const stringArr = string.split(" ");

                stringArr.forEach((s) => {
                    if (s && !validSpelling(s)) {
                        spellingErrors.push(s);
                    }
                });
            };

            const hasNumber = (myString) => {
                return /\d/.test(myString);
            };

            const validSpelling = (char) => {
                if (!dictionary || hasNumber(char)) {
                    return true;
                }

                return dictionary.check(char);
            };

            if (!value || !validation) {
                return spellingErrors;
            }

            switch (validation.type) {
                case "String":
                    if (typeof value === "string") {
                        getSpellingErrorsList(value, spellingErrors);
                    }

                    break;
                case "StringList":
                case "LinkList":
                case "NumberList":
                case "MeasurementList":
                case "Picklist":
                    if (typeof value === "string") {
                        return spellingErrors;
                    }

                    if (Array.isArray(value)) {
                        value.forEach((v) => {
                            if (v && typeof v === "string") {
                                getSpellingErrorsList(v, spellingErrors);
                            } else if (v && v.text && typeof v.text === "string") {
                                getSpellingErrorsList(v.text, spellingErrors);
                            }
                        });
                    } else {
                        if (value.hasOwnProperty("text") && typeof value.text === "string") {
                            getSpellingErrorsList(value.text, spellingErrors);
                        }
                    }

                    break;
                //case 'Measurement':
                //case 'Number':
                //case 'Decimal':
                //case 'Boolean':
                //case 'ColorPicklist':
                default:
                    break;
            }

            return spellingErrors;
        },
        [dictionary],
    );
};

export const charactersOnly = (value) => {
    return value && typeof value === "string" ? value.replace(/[^a-zA-Z0-9' ]/g, "") : value;
};
